var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGifts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.173,19.2557 C19.173,19.3197 19.139,19.3867 19.078,19.4417 C18.995,19.5167 18.874,19.5597 18.746,19.5597 L14.639,19.5597 L14.639,12.3267 L19.173,12.3267 L19.173,19.2557 Z M10.959,19.5587 L13.04,19.5587 L13.04,12.3267 L10.959,12.3267 L10.959,19.5587 Z M4.921,19.4417 C4.86,19.3867 4.826,19.3197 4.826,19.2557 L4.826,12.3267 L9.36,12.3267 L9.36,19.5597 L5.253,19.5597 C5.125,19.5597 5.004,19.5167 4.921,19.4417 L4.921,19.4417 Z M3.599,9.3187 C3.599,9.2537 3.633,9.1887 3.694,9.1337 C3.777,9.0587 3.898,9.0157 4.026,9.0157 L9.36,9.0157 L9.36,10.7277 L4.026,10.7277 L3.599,10.7277 L3.599,9.3187 Z M10.387,7.3107 C8.756,6.9927 7.352,5.9407 6.865,4.7047 C8.496,5.0227 9.899,6.0747 10.387,7.3107 L10.387,7.3107 Z M17.133,4.7047 C16.646,5.9407 15.242,6.9927 13.611,7.3107 C14.099,6.0747 15.503,5.0227 17.133,4.7047 L17.133,4.7047 Z M10.959,10.7277 L13.04,10.7277 L13.04,9.0157 L10.959,9.0157 L10.959,10.7277 Z M20.305,9.1337 C20.366,9.1887 20.4,9.2547 20.4,9.3187 L20.4,10.7277 L19.973,10.7277 L14.639,10.7277 L14.639,9.0157 L19.973,9.0157 C20.101,9.0157 20.221,9.0587 20.305,9.1337 L20.305,9.1337 Z M18.746,21.1587 C19.272,21.1587 19.77,20.9717 20.149,20.6307 C20.546,20.2737 20.773,19.7727 20.773,19.2557 L20.773,12.2927 C21.063,12.2557 21.339,12.1547 21.554,11.9607 C21.837,11.7067 21.999,11.3477 21.999,10.9757 L21.999,9.3187 C21.999,8.8027 21.772,8.3017 21.375,7.9437 C20.997,7.6037 20.499,7.4157 19.973,7.4157 L17.023,7.4157 C18.156,6.4937 18.932,5.2357 18.932,3.7997 C18.932,3.3587 18.574,2.9997 18.132,2.9997 C15.561,2.9997 12.733,4.6587 11.999,7.0277 C11.266,4.6587 8.437,2.9997 5.866,2.9997 C5.424,2.9997 5.066,3.3587 5.066,3.7997 C5.066,5.2357 5.842,6.4937 6.975,7.4157 L4.026,7.4157 C3.5,7.4157 3.002,7.6037 2.624,7.9437 C2.227,8.3007 2,8.8017 2,9.3187 L2,10.9757 C2,11.3477 2.162,11.7067 2.444,11.9597 C2.659,12.1547 2.935,12.2557 3.226,12.2937 L3.226,19.2557 C3.226,19.7727 3.454,20.2737 3.85,20.6307 C4.229,20.9717 4.727,21.1587 5.253,21.1587 L18.746,21.1587 Z",
    id: "path-dfa8dc71-2948-4b44-855f-7985bf43e656"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "6.74170517%",
    y1: "10.6866036%",
    x2: "96.518208%",
    y2: "100.071406%",
    id: "linearGradient-afab540e-12ee-4000-9e60-51c60dd6a5c7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22B580",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49CE8F",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Navigation-/-gifts"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-dfa8dc71-2948-4b44-855f-7985bf43e656",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-dfa8dc71-2948-4b44-855f-7985bf43e656"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Icon-shape",
    fill: "#868B92",
    xlinkHref: "#path-dfa8dc71-2948-4b44-855f-7985bf43e656"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Icon-color",
    fill: "url(#linearGradient-afab540e-12ee-4000-9e60-51c60dd6a5c7)",
    mask: "url(#mask-dfa8dc71-2948-4b44-855f-7985bf43e656)",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGifts);
export default __webpack_public_path__ + "static/media/gifts.145fdaa6fd67941b3cd7604534f61b3d.svg";
export { ForwardRef as ReactComponent };